export function getTopDistance(el: HTMLElement) {
  return el.scrollTop;
}

export function getBottomDistance(el: HTMLElement) {
  return el.scrollHeight - el.clientHeight - el.scrollTop;
}

export function getTopDistanceForFlexReverse(el: HTMLElement) {
  return el.scrollHeight - el.clientHeight + el.scrollTop;
}

export function getBottomDistanceForFlexReverse(el: HTMLElement) {
  return -el.scrollTop;
}
